// ─── Constants (exported for client-side / test reuse) ───

// Inline images sit in running prose, so they don't need the cover's 25 MB
// headroom — cap tighter to keep chapters light for readers.
export const MAX_CHAPTER_IMAGE_SIZE = 10 * 1024 * 1024; // 10 MB
export const CHAPTER_IMAGE_SIZE_LIMIT_LABEL = `${MAX_CHAPTER_IMAGE_SIZE / (1024 * 1024)} MB`;
export const ALLOWED_CHAPTER_IMAGE_MIME_TYPES = new Set([
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/gif",
]);
